import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { UserPlus } from 'lucide-react';

const Registrer = () => {
  const { register, user } = useAuth();
  const nav = useNavigate();
  const [kontotype, setKontotype] = useState('bedrift');
  const [firmaNavn, setFirmaNavn] = useState('');
  const [navn, setNavn] = useState('');
  const [epost, setEpost] = useState('');
  const [passord, setPassord] = useState('');
  const [passord2, setPassord2] = useState('');
  const [feil, setFeil] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (user) nav('/'); }, [user, nav]);

  const erForening = kontotype === 'forening';

  const onSubmit = async (e) => {
    e.preventDefault();
    setFeil('');
    if (!firmaNavn.trim()) return setFeil(erForening ? 'Foreningsnavn er påkrevd.' : 'Firmanavn er påkrevd.');
    if (passord !== passord2) return setFeil('Passordene stemmer ikke.');
    if (passord.length < 8) return setFeil('Passordet må være minst 8 tegn.');
    setBusy(true);
    try { await register(firmaNavn, navn, epost, passord, erForening); nav('/'); }
    catch (err) { setFeil(err.response?.data?.error || 'Registrering feilet.'); }
    finally { setBusy(false); }
  };

  const typeKnapp = (verdi, tittel, undertekst) => (
    <button type="button" onClick={() => setKontotype(verdi)}
            style={{
              flex: 1, padding: '10px 12px', textAlign: 'left', cursor: 'pointer',
              borderRadius: 8, lineHeight: 1.3,
              border: `1.5px solid ${kontotype === verdi ? 'var(--theme-accent)' : 'var(--theme-border)'}`,
              background: kontotype === verdi ? 'var(--theme-accent-soft, rgba(59,130,246,.08))' : 'var(--theme-bg-card)',
            }}>
      <div style={{ fontWeight: 600, fontSize: 13 }}>{tittel}</div>
      <div className="fm-text-muted" style={{ fontSize: 10 }}>{undertekst}</div>
    </button>
  );

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  background: 'var(--theme-bg-primary)', padding: 16 }}>
      <div className="card" style={{ width: '100%', maxWidth: 380, padding: 28 }}>
        <div className="flex items-center" style={{ gap: 10, marginBottom: 6 }}>
          <div style={{ width: 32, height: 32, borderRadius: 8, background: 'var(--theme-accent)',
                        color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontWeight: 700, fontSize: 16 }}>R</div>
          <h1 style={{ margin: 0, fontSize: 18, fontWeight: 700 }}>Opprett konto</h1>
        </div>
        <p className="fm-text-muted" style={{ fontSize: 12, marginTop: 0, marginBottom: 16 }}>
          {erForening
            ? 'Opprett forening med regnskap, medlemsregister, giverside og innsamling.'
            : 'Opprett bedrift med fullt regnskap: bilag, faktura, MVA og lønn.'}
          {' '}Du kan invitere flere brukere senere.
        </p>
        <form onSubmit={onSubmit}>
          <label>Kontotype</label>
          <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
            {typeKnapp('bedrift', 'Bedrift', 'ENK · AS · andre foretak')}
            {typeKnapp('forening', 'Forening', 'Lag · klubb · organisasjon')}
          </div>
          <label>{erForening ? 'Foreningsnavn' : 'Firmanavn'}</label>
          <input value={firmaNavn} onChange={(e) => setFirmaNavn(e.target.value)}
                 required autoFocus style={{ marginBottom: 10 }} />
          <label>Ditt navn</label>
          <input value={navn} onChange={(e) => setNavn(e.target.value)} style={{ marginBottom: 10 }} />
          <label>E-post</label>
          <input type="email" value={epost} onChange={(e) => setEpost(e.target.value)}
                 required style={{ marginBottom: 10 }} />
          <label>Passord</label>
          <input type="password" value={passord} onChange={(e) => setPassord(e.target.value)}
                 required style={{ marginBottom: 10 }} />
          <label>Gjenta passord</label>
          <input type="password" value={passord2} onChange={(e) => setPassord2(e.target.value)}
                 required style={{ marginBottom: 10 }} />
          {erForening && (
            <div className="fm-text-muted" style={{ fontSize: 10, marginBottom: 10 }}>
              Foreningskontoen er tilpasset lag og organisasjoner – med medlemsregister,
              giverside og innsamling i tillegg til vanlig regnskap. Kontotype kan endres senere under Innstillinger.
            </div>
          )}
          {feil && (
            <div className="badge badge-danger" style={{ width: '100%', justifyContent: 'center', padding: 8, marginBottom: 12 }}>
              {feil}
            </div>
          )}
          <button type="submit" disabled={busy} className="btn-primary"
                  style={{ width: '100%', height: 36, justifyContent: 'center' }}>
            <UserPlus size={14} /> {busy ? 'Oppretter…' : 'Opprett konto'}
          </button>
        </form>
        <div style={{ textAlign: 'center', marginTop: 14, fontSize: 12 }}>
          Har du allerede konto? <Link to="/login">Logg inn</Link>
        </div>
      </div>
    </div>
  );
};

export default Registrer;
